import styled from "styled-components";

const ProductCardCarouselElement = styled.div`
    margin-top: 100px;
    .container{
        .seeMore {
            display: flex;
            align-items: baseline;
            h5 {
                color: #2bc06d;
                padding-left: 20px;
            }
        }
       
    }
`

export default ProductCardCarouselElement;